import React from "react";
import {
  FiEdit,
  FiEye,
  FiTrash2,
  FiUserPlus,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

const CustomerTable = ({
  customers = [],
  loading,
  pagination,
  onView,
  onEdit,
  onDelete,
  onChangeStatus,
  onPageChange,
  onLimitChange,
  onAddCustomer,
}) => {

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "customer-status-active";

      case "Inactive":
        return "customer-status-inactive";

      case "Blocked":
        return "customer-status-blocked";

      default:
        return "customer-status-active";
    }
  };

  const nextStatus = (status) => {
    if (status === "Active") return "Inactive";
    if (status === "Inactive") return "Blocked";
    return "Active";
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="customer-table-card">

      <div className="customer-table-scroll">

        <table className="customer-table">

          <thead>

            <tr>

              <th width="70">#</th>

              <th>Customer</th>

              <th>Mobile</th>

              <th>Email</th>

              <th>Company</th>

              <th>Status</th>

              <th>Created</th>

              <th width="180">Action</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan={8}
                  className="customer-table-message"
                >

                  <div className="customer-table-loading">

                    <div className="customer-table-spinner" />

                    Loading Customers...

                  </div>

                </td>

              </tr>

            ) : customers.length === 0 ? (

              <tr>

                <td
                  colSpan={8}
                  className="customer-table-message"
                >

                  <div className="customer-table-empty">

                    <FiUserPlus />

                    <strong>
                      No Customers Found
                    </strong>

                    <span>
                      Click below to add your first
                      customer.
                    </span>

                    <button
                      onClick={onAddCustomer}
                    >
                      <FiUserPlus />

                      Add Customer

                    </button>

                  </div>

                </td>

              </tr>

            ) : (

              customers.map((customer, index) => (

                <tr key={customer._id}>

                  <td className="customer-table-serial">

                    {(pagination.page - 1) *
                      pagination.limit +
                      index +
                      1}

                  </td>

                  <td>

                    <div className="customer-table-profile">

                      <div className="customer-table-avatar">

                        {customer.customerName
                          ?.charAt(0)
                          ?.toUpperCase()}

                      </div>

                      <div className="customer-table-profile-info">

                        <strong>

                          {customer.customerName}

                        </strong>

                        <span>

                          ID :
                          {" "}
                          {customer._id.slice(-6)}

                        </span>

                      </div>

                    </div>

                  </td>

                  <td>

                    {customer.mobile}

                  </td>

                  <td>

                    {customer.email || "-"}

                  </td>

                  <td
                    className="customer-table-company"
                  >

                    {customer.companyName || "-"}

                  </td>

                  <td>

                    <button
                      className={`customer-status-badge ${getStatusClass(
                        customer.status
                      )}`}
                      onClick={() =>
                        onChangeStatus(
                          customer,
                          nextStatus(
                            customer.status
                          )
                        )
                      }
                    >

                      {customer.status}

                    </button>

                  </td>

                  <td className="customer-table-date">

                    {formatDate(
                      customer.createdAt
                    )}

                  </td>

                  <td>

                    <div className="customer-table-actions">

                      <button
                        className="customer-table-action-button customer-table-action-view"
                        title="View"
                        onClick={() =>
                          onView(customer)
                        }
                      >

                        <FiEye />

                      </button>

                      <button
                        className="customer-table-action-button customer-table-action-edit"
                        title="Edit"
                        onClick={() =>
                          onEdit(customer)
                        }
                      >

                        <FiEdit />

                      </button>

                      <button
                        className="customer-table-action-button customer-table-action-delete"
                        title="Delete"
                        onClick={() =>
                          onDelete(customer)
                        }
                      >

                        <FiTrash2 />

                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

      <div className="customer-pagination">

        <div className="customer-pagination-summary">

          Showing

          {" "}

          <strong>

            {customers.length}

          </strong>

          {" "}

          of

          {" "}

          <strong>

            {pagination.total}

          </strong>

          {" "}

          Customers

        </div>

        <div className="customer-pagination-controls">

          <select
            value={pagination.limit}
            onChange={onLimitChange}
          >

            <option value={10}>
              10
            </option>

            <option value={20}>
              20
            </option>

            <option value={50}>
              50
            </option>

            <option value={100}>
              100
            </option>

          </select>

          <button
            disabled={
              pagination.page === 1
            }
            onClick={() =>
              onPageChange(
                pagination.page - 1
              )
            }
          >

            <FiChevronLeft />

          </button>

          <span>

            Page

            {" "}

            <strong>

              {pagination.page}

            </strong>

            {" "}

            of

            {" "}

            <strong>

              {pagination.totalPages}

            </strong>

          </span>

          <button
            disabled={
              pagination.page ===
              pagination.totalPages
            }
            onClick={() =>
              onPageChange(
                pagination.page + 1
              )
            }
          >

            <FiChevronRight />

          </button>

        </div>

      </div>

    </div>
  );
};

export default CustomerTable;